package com.pincer.core.rules

import com.pincer.core.InvalidData
import com.pincer.core.model.tree.Candidate

class DurationRule(val duration: Int): Rule() {

    override fun score(candidate: Candidate): Float {
        val candidateDuration = candidate.duration() ?: return MIGHT_BE_POSSIBLE
        if (candidateDuration == duration) return DEFINITELY_POSSIBLE
        return DEFINITELY_NOT_POSSIBLE
    }

    companion object {
        fun parse(params: List<String>): DurationRule {
            if (params.size != 1) throw InvalidData("The duration rule needs exactly one number parameter")
            try {
                val build = DurationRule(params.first().toInt())
                if (build.duration < 1) throw InvalidData("The number in the duration rule can not be less that one")
                return build
            }
            catch (nfe: NumberFormatException) { throw InvalidData("The number in the duration rule looks wrong") }
        }
    }

}
